import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { successAlert, errorAlert } from "../Alerts/actions";
import api from "../../utils/api";
import QueryString from "query-string";
import {
  FETCH_HOME_GROUP_ADMINS,
  GET_VIEW_DATA,
  ADD_HOME_GROUP_ADMIN,
  EDIT_HOME_GROUP_ADMIN,
  DELETE_HOME_GROUP_ADMIN,
  GET_CHECK_MASTER_ADMIN,
  OPEN_ADMIN_EDIT_MODAL,
  INVITE_ADMIN,
} from "./constants";
import {
  fetchHomeGroupAdmins as fetchHomeGroupAdminsAction,
  fetchHomeGroupAdminsSuccess,
  fetchHomeGroupAdminsFailure,
  //
  getViewData as getViewDataAction,
  getViewDataSuccess,
  getViewDataFailure,
  //
  addHomeGroupAdminSuccess,
  addHomeGroupAdminFailure,
  //
  editHomeGroupAdminSuccess,
  editHomeGroupAdminFailure,
  //
  deleteHomeGroupAdminSuccess,
  deleteHomeGroupAdminFailure,
  //
  getCheckMasterAdminSuccess,
  getCheckMasterAdminFailure,
  //
  setAdminSuccess,
  setAdminFailure,
  //
  inviteAdminSuccess,
  inviteAdminFailure,
} from "./actions";

export function* fetchHomeGroupAdminsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company-admin?${query}`);
    yield put(fetchHomeGroupAdminsSuccess(data));
  } catch (e) {
    yield put(fetchHomeGroupAdminsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching admins!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* getEditDataSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin/${payload}`
    );
    yield put(setAdminSuccess(data));
  } catch (e) {
    yield put(setAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching admin!"));
  }
}

export function* getCheckMasterAdminSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin/check-master-admin/${payload}`
    );
    yield put(getCheckMasterAdminSuccess(data));
  } catch (e) {
    yield put(getCheckMasterAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* addHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Admin added successfully!"));
      yield put(addHomeGroupAdminSuccess());
      yield put(
        fetchHomeGroupAdminsAction({
          page: 1,
          limit: 10,
          company_id: payload.data.company_id,
        })
      );
    }
  } catch (e) {
    yield put(addHomeGroupAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Admin updated successfully!"));
      yield put(editHomeGroupAdminSuccess());
      if (payload?.history) {
        payload.history.push(
          `/d/company/edit/${payload.data.company_id}/admins`
        );
      }
      yield put(
        fetchHomeGroupAdminsAction({
          page: 1,
          limit: 10,
          company_id: payload.data.company_id,
        })
      );
    }
  } catch (e) {
    yield put(editHomeGroupAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteHomeSaga({ payload, onDeleteSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/company-admin/${payload}`);
    if (data) {
      yield put(successAlert("Admin deleted successfully!"));
      yield put(deleteHomeGroupAdminSuccess());
      typeof onDeleteSuccess === "function" && onDeleteSuccess();
    }
  } catch (e) {
    yield put(deleteHomeGroupAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* inviteAdminSaga({ payload, onInvSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin-invite`,
      payload
    );
    if (data) {
      yield put(successAlert("Invite sent successfully!"));
      yield put(inviteAdminSuccess());
      typeof onInvSuccess === "function" && onInvSuccess();
    }
  } catch (e) {
    yield put(inviteAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchHomeGroupAdminsFlow() {
  yield takeEvery(FETCH_HOME_GROUP_ADMINS, fetchHomeGroupAdminsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* getCheckMasterAdminFlow() {
  yield takeEvery(GET_CHECK_MASTER_ADMIN, getCheckMasterAdminSaga);
}
export function* addHomeFlow() {
  yield takeEvery(ADD_HOME_GROUP_ADMIN, addHomeSaga);
}
export function* editHomeFlow() {
  yield takeEvery(EDIT_HOME_GROUP_ADMIN, editHomeSaga);
}
export function* deleteHomeFlow() {
  yield takeEvery(DELETE_HOME_GROUP_ADMIN, deleteHomeSaga);
}
export function* getEditDataFlow() {
  yield takeEvery(OPEN_ADMIN_EDIT_MODAL, getEditDataSaga);
}
export function* inviteAdminFlow() {
  yield takeEvery(INVITE_ADMIN, inviteAdminSaga);
}

export default function* HomeGroupsAdminSaga() {
  yield all([
    fetchHomeGroupAdminsFlow(),
    addHomeFlow(),
    editHomeFlow(),
    deleteHomeFlow(),
    getViewDataFlow(),
    getCheckMasterAdminFlow(),
    getEditDataFlow(),
    inviteAdminFlow(),
  ]);
}
